import React from 'react';
import styles from './styles/contactForm.module.css';

const ContactForm = () => {

    return (
        <>
            <form action="" className={styles.form}>
                <label htmlFor="firstName">First Name<br />
                    <input type="text" id="firstName" name="firstName" value="" placeholder="Enter your first name" className={styles.formInput} required />
                </label>

                <label htmlFor="lastName">Last Name<br />
                    <input type="text" id="lastName" name="lastName" value="" placeholder="Enter your last name" className={styles.formInput} required />
                </label>

                <label htmlFor="email">Email<br />
                    <input type="text" id="email" name="email" value="" placeholder="Enter your email address" className={styles.formInput} required />
                </label>

                <label htmlFor="message">Message<br />
                    <textarea type="text" id="message" name="message" value="" placeholder="Type in your message here" className={styles.formTextArea} required />
                </label>

                <input type="submit" value="Send" className={styles.formSubmit} />
            </form>
        </>
    );
}
 
export default ContactForm;